export default "__VITE_ASSET__3geKlpJq__"